import { ErrorResponseErrorItemCodeAuth } from '../../../../typings/api/skymap/rest/v1/.common';

export const translations: Record<ErrorResponseErrorItemCodeAuth, string> = {
  'auth:invalid_credentials': 'Felaktig e-postadress eller lösenord.',
  'auth:user_disabled': 'Användaren är inaktiverad.',
};
